export default "__VITE_ASSET__0HKmv97C__"